import request from 'umi-request'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')
export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')
export const CRMBASE = window.$envUtils('VUE_APP_CRM_SERVICE')
// 全局热搜词
export async function getHotWord() {
  return request(`${CRMBASE}/search/hot-word`, {
    method: 'get'
  })
}

// 关键字查询出来的QA
export async function getSearch(params) {
  return request(`${CRMBASE}/search/searchResult`, {
    params
  })
}

// 获取操作记录接口
export async function getOperationLog(params) {
  return request(`${BPBASE}/system/operation_log/get`, {
    method: 'get',
    params
  })
}

// 坐席工作台客户查询[手机号or姓名or visitid](精确匹配)
export async function getClientInfo(source, param) {
  return request(`${CRMBASE}/customer/current/${source}/${param}`, {
    method: 'get'
  })
}

// 保存客户信息
export async function saveClient(data) {
  return request(`${CRMBASE}/customer`, {
    method: data.id ? 'put' : 'post',
    data
  })
}

// 更新客户在线/呼叫应用场景时间
export async function updateClientTime(data) {
  return request(`${CRMBASE}/customer/updateTime`, {
    method: 'put',
    data
  })
}

// 保存客户关联标签
export async function saveCustomerLabel(data) {
  return request(`${CRMBASE}/customer-label/`, {
    method: 'post',
    data
  })
}

// 删除客户关联标签
export async function delCustomerLabel(data) {
  return request(`${CRMBASE}/customer-label/delete/`, {
    method: 'delete',
    data
  })
}
// 分页查询标签ids
export async function getLabelList(data) {
  return request(`${CRMBASE}/label/listLabels`, {
    method: 'POST',
    data
  })
}

// 查询全部标签
export async function getAllLabelList() {
  return request(`${CRMBASE}/label/listAllLabels`, {
    method: 'get'
  })
}

// 获取访客轨迹
export async function getVisitorStepList(params) {
  return request(`${BPBASE}/data/session_log/get`, {
    method: 'get',
    params
  })
}

// 获取访客轨迹详情
export async function getChatLog(params) {
  return request(`${BPBASE}/data/chat_log/get`, {
    method: 'get',
    params
  })
}

// 查询开启的字段
export async function getOpenCols(params) {
  return request(`${CRMBASE}/customerCol/findOpenCols/${params}`, {
    method: 'get'
  })
}

// 根据筛选条件查询自定义字段集合
export async function getCustomerField(params) {
  return request(`${BPBASE}/system/custom_field/get`, {
    method: 'get',
    params
  })
}

// 获得跟时间有关的模型组
export async function getTimeModels(params) {
  return request(`${QCBASE}/widget/rtc/getTimeModels`, {
    method: 'get',
    params
  })
}

// 聊天
export async function sendChat(params) {
  return request(`${QCBASE}/widget/rtc/doChat`, {
    method: 'get',
    params
  })
}
// 聊天
export async function addTimeChat(params) {
  return request(`${QCBASE}/widget/rtc/addTimeChat`, {
    method: 'get',
    params
  })
}
// 从缓存中获取ChatRecord
export async function getSessionChatRecords(params) {
  return request(`${QCBASE}/widget/rtc/getSessionChatRecords`, {
    method: 'get',
    params
  })
}

// 取客服组
export async function getCustomerGroup() {
  return request(`${BPBASE}/skillgroup/getSkillGroup`, {
    method: 'get'
  })
}

export const AIBASE = window.$envUtils('VUE_APP_ASSIST_SERVICE')
// 查询话术
export async function getSkillsQuery(params) {
  return request(`${AIBASE}/ibotUI/relatedQuestion`, {
    method: 'get',
    params
  })
}

// 进入场景
export async function getSkillsScene(params) {
  return request(`${AIBASE}/ibotUI/ask`, {
    method: 'get',
    params
  })
}

// 智能学习
export async function manualSuggestedMsg(params) {
  return request(`${AIBASE}/ibotUI/manualSuggested`, {
    method: 'get',
    params
  })
}

export const AFF = window.$envUtils('VUE_APP_AFF_SERVICE')

export async function saveAff(data) {
  return request(`${AFF}/nissan/orderLog`, {
    method: 'post',
    data
  })
}

export async function askAff(data) {
  return request(`${AFF}/nissan/ask`, {
    method: 'post',
    data
  })
}

export async function rCust(params) {
  return request(`${AFF}/nissan/rCust`, {
    method: 'get',
    params
  })
}

// 工单集合查询
export const getOrderLogList = (params) => {
  return request(`${AFF}/nissan/orderLog`, { params })
}

// 摘要
export const summary = (data) => {
  return request(`${AFF}/nissan/summary`, {
    method: 'post',
    data
  })
}

// 存缓存
export const setAffHttpCache = (params) => {
  return request(`${AFF}/nissan/addDataCache`, {
    method: 'post',
    data: params
  })
}

// 取缓存
export async function getAffHttpCache(params) {
  return request(`${AFF}/nissan/getDataCache`, {
    method: 'post',
    data: params
  })
}
